import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { EMPTY_PLACEHOLDER } from '../wingmanIntelligenceMetrics';

import { portalMetricTileSx } from '../../../styles/portalSurfaces';

const ICON_BG = 'text.disabled';

const ICON_BY_KEY = {
  baseline: CheckIcon,
  dropoff: WarningAmberRoundedIcon,
  synergy: CalendarTodayOutlinedIcon,
};

const ImpactIcon = ({ IconComponent }) => (
  <Box
    sx={{
      width: 40,
      height: 40,
      borderRadius: '50%',
      bgcolor: ICON_BG,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    }}
  >
    <IconComponent sx={{ fontSize: 22, color: 'common.white' }} />
  </Box>
);

const ImpactAnalysisSection = ({ items = [] }) => {
  return (
    <Box sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography
        variant="subtitle1"
        component="h2"
        sx={{
          fontWeight: 700,
          color: 'text.primary',
          letterSpacing: '-0.01em',
          mb: 2,
        }}
      >
        Wingman Impact Analysis
      </Typography>

      {items.length === 0 ? (
        <Typography sx={{ fontSize: 14, color: 'text.secondary' }}>{EMPTY_PLACEHOLDER}</Typography>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, flexGrow: 1 }}>
          {items.map((item) => {
            const Icon = item.icon ?? ICON_BY_KEY[item.key] ?? CheckIcon;
            return (
              <Box
                key={item.key}
                sx={{
                  ...portalMetricTileSx,
                  p: 1.75,
                  display: 'flex',
                  gap: 1.5,
                  alignItems: 'flex-start',
                }}
              >
                <ImpactIcon IconComponent={Icon} />
                <Box sx={{ minWidth: 0, pt: 0.25 }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 700,
                      color: 'text.primary',
                      lineHeight: 1.35,
                      mb: 0.75,
                    }}
                  >
                    {item.title ?? EMPTY_PLACEHOLDER}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 13,
                      fontWeight: 400,
                      color: 'text.secondary',
                      lineHeight: 1.5,
                    }}
                  >
                    {item.body ?? EMPTY_PLACEHOLDER}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
};

export default ImpactAnalysisSection;
